import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { CommunicationType } from '../../interfaces/reset-pwd.interface';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CheckboxComponent, DropdownComponent, EmailComponent, EqValidator, NumberInputComponent, PasswordComponent, RadioButtonComponent, SearchComponent, TextAreaComponent, TextInputComponent } from '@equine-ui-nx/ui';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'reset-password-link-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatIconModule,
    EmailComponent,
    PasswordComponent,
    CheckboxComponent,
    TextAreaComponent,
    TextInputComponent,
    RadioButtonComponent,
    SearchComponent,
    DropdownComponent,
    NumberInputComponent],
  templateUrl: './reset-password-link-form.component.html',
  styleUrl: './reset-password-link-form.component.scss',
})
export class ResetPasswordLinkFormComponent implements OnInit {
  @Output() passwordLinkData: EventEmitter<any> = new EventEmitter<any>()
  @Input() isPasswordLinkSent: boolean = false;
  @Input() appName !: string;
  resetPwdLinkForm = new FormGroup({});
  unsubscribe$ = new Subject<void>();
  emailExistsError: string = '';
  loading: boolean = false;
  communicationType = CommunicationType;
  resetPwdError: string = '';
  formData = {};
  backgroundImageId!: string
  logoUrl!: string
  constructor(private snackBar: MatSnackBar) { }

  ngOnInit(): void {    
    if(this.appName == 'arenaEqApp'){
      this.backgroundImageId = 'intro-arena';
      this.logoUrl = `assets/images/arenaEq-logo.png`
    }else{
      this.backgroundImageId = 'intro-iea';
      this.logoUrl = `../../../assets/images/access-logo-full.png`
    }
   }
  requiredValidator = {
    validators: Validators.required,
    message: 'This field is required',
    error: 'required',
  };
  emailValidators: EqValidator[] = [
    this.requiredValidator,
    {
      validators: Validators.email,
      message: 'Please enter valid email Address.',
      error: 'email'
    },
    {
      validators: Validators.pattern(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),
      message: 'Please enter valid email.',
      error: 'pattern',
    },
  ]

  resetPwd() {
    if (this.resetPwdLinkForm.valid) {
      this.formData = this.resetPwdLinkForm.value;
      const passwordData = {
        formData: this.resetPwdLinkForm.value,
        type: "passwordlink"
      }
      this.passwordLinkData.emit(passwordData);
    } else {
      this.snackBar.open(`Error: Please enter valid email`, 'Dismiss', { duration: 3000, panelClass:['error-snackbar'] });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  resend() {
    const passwordData = {
      formData: this.formData,
      type: "passwordlink"
    }
    this.passwordLinkData.emit(passwordData);
  }

  checkEmailExists(value: any) {
    if (!this.resetPwdLinkForm.get('email')?.errors) {
      const passwordData = {
        formData: value,
        type: "reserpassword"
      }
      this.passwordLinkData.emit(passwordData);
    }
  }

}
